/* eslint-disable react/prop-types */
import React from 'react';
import request from '@api';
import raImage from '@assets/Return assurance.png';
import gddImage from '@assets/Delivery guarantee.png';
import irImage from '@assets/Instand refund.png';
import bpImage from '@assets/Buyer protection.png';
import { PRODUCT_NAME, BP_INSURANCE_ID_MAP } from '../constants';
import useConnectionContext from './useConnectionContext';

const {
  RETURN_ASSURANCE, BUYER_PROTECTION, SHIPPING_PROTECTION, GREEN_SHIPPING_PROTECTION, BUYBACK_GUARANTEE, EXTENDED_WARRANTY, INSTANT_REFUND, GUARANTEED_DELIVERY_DATE, ESTIMATED_DELIVERY_DATE, ASSURED_SALE, DELIVERY_GUARANTEE, WORRY_FREE_PURCHASE, RETURNABLE,
} = PRODUCT_NAME;

export const productsCode = {
  BP: 'BP', RA: 'RA', IR: 'IR', GDD: 'GDD', EDD: 'EDD',
};

// learn more link in product page
export const learnMoreMap = {
  [BUYER_PROTECTION]: 'https://www.seel.com/on-time-delivery-guarantee',
  [SHIPPING_PROTECTION]: 'https://www.seel.com/on-time-delivery-guarantee',
  [GREEN_SHIPPING_PROTECTION]: 'https://www.seel.com/on-time-delivery-guarantee',
  [DELIVERY_GUARANTEE]: 'https://www.seel.com/on-time-delivery-guarantee',
  [WORRY_FREE_PURCHASE]: 'https://www.seel.com/on-time-delivery-guarantee',
  [RETURN_ASSURANCE]: 'https://www.seel.com/buy-as-refundable',
  [RETURNABLE]: 'https://www.seel.com/buy-as-refundable',
  [INSTANT_REFUND]: '',
  [GUARANTEED_DELIVERY_DATE]: '',
  [ESTIMATED_DELIVERY_DATE]: '',
  [ASSURED_SALE]: '',
  [BUYBACK_GUARANTEE]: 'https://www.seel.com/buyback-guaranteed',
  [EXTENDED_WARRANTY]: 'https://www.seel.com/product-protection',
};
export const settingsMap = {
  [BUYER_PROTECTION]: '/bp/settings',
  [GREEN_SHIPPING_PROTECTION]: '/bp/settings',
  [DELIVERY_GUARANTEE]: '/bp/settings',
  [WORRY_FREE_PURCHASE]: '/bp/settings',
  [RETURN_ASSURANCE]: '/ra/settings',
  [RETURNABLE]: '/ra/settings',
};

const ProductsContext = React.createContext();

export const ProductsProvider = ({ children }) => {
  const [productsGallery, setProductGallery] = React.useState([]);
  const [productsInvolved, setProductInvolved] = React.useState([]);
  const { merchantId, appInstalled, store: { name } = {} } = useConnectionContext();
  const [galleryLoading, setGalleryLoading] = React.useState(true);
  const [involvedLoading, setInvolvedLoading] = React.useState(true);

  const checkAuthorization = async (productType = '') => {
    const { code, data } = await request('can_apply', { method: 'POST', body: { merchantId, productType } }).catch(console.log);
    const { canApply } = data || {};
    return code === 0 ? canApply : false;
  };

  React.useEffect(() => {
    const getProductsInvolved = async () => {
      try {
        const { code, data } = await request('get-all-status');
        if (code === 0) {
          // TODO: 待优化，目前每新增一个产品就需要添加一个字段，期望后台返回值的接口统一格式
          const {
            gddStatusResponse = {},
            raStatusResponse = {},
            eddStatusResponse = {},
            bpStatusResponse = {},
            asStatusResponse = {},
            ewStatusResponse = {},
            wfpStatusResponse = {},
          } = data || {};
          let involved = [{
            icon: gddImage,
            name: GUARANTEED_DELIVERY_DATE,
            status: gddStatusResponse.status,
            liveDate: gddStatusResponse.liveDate,
            settingHref: 'soon', // 入口放出
            policyHref: '/policies',
          },
          {
            icon: raImage,
            name: RETURN_ASSURANCE,
            status: raStatusResponse.status,
            // status: 'pending',
            liveDate: raStatusResponse.liveDate,
            settingHref: '/ra/settings',
            policyHref: '/policies',
          },
          {
            icon: gddImage,
            name: ESTIMATED_DELIVERY_DATE,
            status: eddStatusResponse.status,
            liveDate: eddStatusResponse.liveDate,
            settingHref: 'soon',
            policyHref: '/policies',
          }, {
            icon: bpImage,
            name: SHIPPING_PROTECTION,
            status: bpStatusResponse.status,
            liveDate: bpStatusResponse.liveDate,
            settingHref: '/bp/settings',
            policyHref: '/policies',
          }, {
            icon: irImage,
            name: ASSURED_SALE,
            status: asStatusResponse.status,
            liveDate: asStatusResponse.liveDate,
            settingHref: 'soon',
            policyHref: '/policies',
          }, {
            icon: irImage,
            name: EXTENDED_WARRANTY,
            status: ewStatusResponse.status,
            liveDate: ewStatusResponse.liveDate,
            settingHref: 'soon',
          }, {
            icon: bpImage,
            name: WORRY_FREE_PURCHASE,
            status: wfpStatusResponse.status,
            settingHref: 'soon',
          }];
          involved = involved.filter(
            (item) => (!!(item.status !== undefined && item.status !== null)),
          );
          console.log('Products Involved', involved);
          setProductInvolved(involved);
          setInvolvedLoading(false);
        }
      } catch (e) {
        console.log(e);
      }
    };
    if (name) {
      getProductsInvolved();
    }
  }, [name]);

  React.useEffect(() => {
    const getProductsGallery = async () => {
      try {
        const { code, data } = await request(`get-visible-merchant-insurance-products?merchantId=${merchantId}`);
        if (code !== 0) {
          return;
        }
        const { merchantInsuranceProductsVOList: seelProducts } = data || {};
        let authorized = false;
        // 有 EDD 产品的时候才去调用 can_apply 接口确认权限
        if (seelProducts?.filter((item) => item.insuranceId === '7')?.length) {
          authorized = await checkAuthorization('EDD');
        }
        const gallery = seelProducts.map((item) => {
          if (item.insuranceId === '7') {
            return {
              ...item,
              authorized: appInstalled === false ? appInstalled : authorized,

            };
          }
          // 0 - shopify return assurance 4 - shopify delivery guarantee
          if (item.insuranceId === '0' || item.insuranceId === '4') {
            return {
              ...item,
              authorized: appInstalled,

            };
          }
          return item;
        }).sort((a, b) => a.insuranceId - b.insuranceId);
        // console.log('Products Gallery', gallery);
        setProductGallery(gallery);
        setGalleryLoading(false);
      } catch (e) {
        console.log(e);
      }
    };
    if (merchantId) {
      getProductsGallery();
    }
  }, [merchantId, appInstalled]);

  const value = React.useMemo(
    () => {
      // gallery 中增加involved的status 方便products页面使用
      const gallery = productsGallery.map((item) => {
        let isBP = false;
        const { status: involvedStatus, liveDate } = productsInvolved.find((v) => {
          // 代表不同平台的bp 由于各个平台的insuranceName有所差别导致productsInvolved中找不到对应的insuranceName
          if (BP_INSURANCE_ID_MAP.includes(item.insuranceId)) {
            isBP = true;
            return v.name === PRODUCT_NAME.SHIPPING_PROTECTION;
          }
          return item.insuranceName.indexOf(v.name) > -1 || item.insuranceName === PRODUCT_NAME.RETURNABLE;
        }) || {};
        // const learnMore = learnMoreMap[item.insuranceName];
        const settingsHref = settingsMap[item.insuranceName];
        return {
          ...item,
          involvedStatus,
          liveDate,
          settingsHref,
          isBP,
          // learnMore,
        };
      });
      console.log('Products Gallery', gallery);
      return ({
        productsGallery: gallery, productsInvolved, galleryLoading, involvedLoading,
      });
    },
    [productsGallery, productsInvolved, galleryLoading, involvedLoading],
  );

  return <ProductsContext.Provider value={value}>{children}</ProductsContext.Provider>;
};

const useProductsContext = () => React.useContext(ProductsContext);

export default useProductsContext;
